import { render, staticRenderFns } from "./DemandForm.vue?vue&type=template&id=de61cb9a"
import script from "./DemandForm.vue?vue&type=script&lang=js"
export * from "./DemandForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports